import { parse, stringify } from "superjson";
import type { FormVersion } from "../state/formVersion";

export const serializeFormVersion = (value: FormVersion | null): string => stringify(value);
export const deserializeFormVersion = (value: string): FormVersion | null => parse<FormVersion | null>(value);
